import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';
import { formatInvoiceNumber } from '../utils/formatUtils';

export const differimentInvoiceKeys = {
  all: ['differimentInvoices'],
  list: (filters) => [...differimentInvoiceKeys.all, 'list', filters],
};

export const useDifferimentInvoices = (filters, options = {}) => {
  const params = {};
  if (filters?.startDate) params.start_date = filters.startDate;
  if (filters?.endDate) params.end_date = filters.endDate;
  if (filters?.contractNumber) params.contract_number = filters.contractNumber;
  if (filters?.page && filters.page > 0) params.offset = (filters.page - 1) * (filters.limit || 15);
  if (filters?.limit) params.limit = filters.limit;

  return useQuery({
    queryKey: differimentInvoiceKeys.list(params),
    queryFn: async () => {
      const response = await apiClient.get('differiment-invoices', { params });
      const data = Array.isArray(response.data) ? response.data : [];
      return data.map((inv) => ({
        ...inv,
        formatted_number: formatInvoiceNumber(
          'B',
          inv.sale_point_number,
          inv.receipt_number
        ),
      }));
    },
    keepPreviousData: true,
    staleTime: 2 * 60 * 1000,
    ...options,
  });
};

export const useDifferimentInvoicePrint = () => {
  return useMutation({
    mutationFn: async (uuidInvoice) => {
      const response = await apiClient.get(`differiment-invoices/${uuidInvoice}/print`);
      const { pdf_base64, download_name } = response.data;

      if (pdf_base64) {
        const byteCharacters = atob(pdf_base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i += 1) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', download_name || 'factura_diferimiento.pdf');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }

      return response.data;
    },
  });
};

